import React, { useEffect } from 'react'
import styled from 'styled-components'

const ThankyouStyle = styled.div`
.main-section {
    font-family: sans-serif;
    padding: 100px;
    text-align: center;
    color: var(--blue);
    background: #fff;
}
`;
const ThankYou = () => {
    return (
        <ThankyouStyle>
            <div className='main-section'>
                <h2>Thank You! You have Successfully Registered</h2>
            </div>
        </ThankyouStyle>
    )
}

export default ThankYou;